<div class="slot_games--info">
  <div class="slot_games--info_container">
    <div class="slot_games--info_item card-1">
      <div class="slot_games--info_img">
        <img src="{{siteUrlPath}}/{{mediaUrlPath}}/box-1.png" alt="Latest Released Games">
        
      </div>
      <div class="slot_games--info_content">
        <h2>{{'slotboxes.latest1' | translate }}<br>{{'slotboxes.latest2' | translate }}</h2>
        <a (click)="goToGames('new')" > <button>{{'slotboxes.view_games' | translate}}</button> </a>
      </div>
    </div>
    <div class="slot_games--info_item card-2">
      <div class="slot_games--info_img">
        <img src="{{siteUrlPath}}/{{mediaUrlPath}}/box-2.png" alt="Top Games in your area">
      </div>
      <div class="slot_games--info_content">
        <h2>{{'slotboxes.Top_Games1' | translate}}<br>{{'slotboxes.Top_Games2' | translate}}</h2>
        <a (click)="goToGames('featured_games')">
          <button>{{'slotboxes.view_games' | translate}}</button>
        </a>
      </div>
    </div>
    <div class="slot_games--info_item card-3">
      <div class="slot_games--info_img">
        <img src="{{siteUrlPath}}/{{mediaUrlPath}}/box-3.png" alt="Live Casino Games">
      </div>
      <div class="slot_games--info_content">
        <h2>{{'slotboxes.Live_Casino1' | translate}}<br>{{'slotboxes.Live_Casino2' | translate}}</h2>
        <a (click)="goToGames('live_casino')" ><button>{{'slotboxes.view_games' | translate}}</button></a>
      </div>
    </div>
  </div>
</div>